import { Badge } from "@mui/material";
import useToggleMenu from "hooks/useToggleMenu";
import SecondaryButton from "library/Atoms/Button/SecondaryButton";
import PropTypes from "prop-types";
import { forwardRef, useImperativeHandle } from "react";
import Menu from "../Menu";
import styles from "./styles";

const FilterTriggerButton = ({ id, label, onClick, icon, invisible, ...restProps }) => (
  <Badge
    componentsProps={{ badge: { className: styles.badge } }}
    variant="dot"
    color="primary"
    overlap="circular"
    invisible={invisible}
    data-cy={`${id}-badge`}
  >
    <SecondaryButton
      id={id}
      className="p-3"
      label={
        <>
          {icon}

          {label && (
            <span className="pl-2 text-fs-12 text-fw-normal text-color-grey900" data-cy={`${id}-label`}>
              {label}
            </span>
          )}
        </>
      }
      onClick={onClick}
      {...restProps}
    />
  </Badge>
);

FilterTriggerButton.defaultProps = {
  label: null,
};

FilterTriggerButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node.isRequired,
  invisible: PropTypes.bool.isRequired,
};

const Filter = forwardRef(({ id, className, label, children, icon, badge, ...restProps }, ref) => {
  const [{ anchorEl, isOpen: isFilterOpen }, onOpenFilterMenu, onCloseFilterMenu] = useToggleMenu(false);

  useImperativeHandle(ref, () => ({
    openMenu: onOpenFilterMenu,
    closeMenu: onCloseFilterMenu,
  }));

  return (
    <>
      <FilterTriggerButton
        id={id}
        icon={icon}
        label={label}
        onClick={onOpenFilterMenu}
        invisible={!badge}
        {...restProps}
      />

      {isFilterOpen && (
        <Menu className={className} anchorEl={anchorEl} onClose={onCloseFilterMenu} data-cy={`${id}-menu`}>
          {children}
        </Menu>
      )}
    </>
  );
});

Filter.defaultProps = {
  className: null,
  label: null,
  badge: false,
};

Filter.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.node,
  children: PropTypes.node.isRequired,
  icon: PropTypes.node.isRequired,
  badge: PropTypes.bool,
};

Filter.TriggerButton = FilterTriggerButton;

export default Filter;
